module.exports = __webpack_public_path__ + "media/images/new_landing/about/story-1-2f2f76e87b71972bee5bf8499979f3d3.jpg";